import React, { FunctionComponent, useCallback, useContext, useMemo } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { EditorContext } from '../context';
import { ReactComponent as CloudIcon } from '../../../../assets/icons/main/cloud-icon.svg';
import {Box, IconButton, Paper, Stack, Tooltip, Typography, lighten, useTheme} from "@mui/material";
// import {ReactComponent as DeleteIcon} from '../../../../assets/DeleteIcon.svg';
import { ReactComponent as AddCircleIcon } from '../../../../assets/icons/main/plus-circle-icon.svg';
import {palette} from '../../../../theme/palette';
import { useOutletContext } from 'react-router-dom';
import { get } from 'lodash';


const Styles = {
  nodeWrapper: {
    height: '48px',
    position: 'relative',
    borderRadius: '12px',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '200px',
  },
  iconWrapper: {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '11px 0 0 11px',
    backgroundColor: palette.primary.main,
  },
  icon: {
    height: '48px',
    width: '48px',
  },
  handleSource: {
    height: '1px',
    width: '1px',
    backgroundColor: 'transparent',
    left: 0
  },
  handleTarget: {
    height: '1px',
    width: '1px',
    backgroundColor: 'transparent',
    right: 0
  },
  addIcon: {
    position: 'absolute',
    left: '-36px'
  }
}

export const CloudNode: FunctionComponent<NodeProps> = ({ id, data, xPos, yPos }: NodeProps) => {
  const { addNode, editable, showAddModal, hasAccessTo } = useContext(EditorContext);
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  // console.log(id, data, xPos, yPos, 'HELLO');

  const hasReadOnlyAccess = !(hasAccessTo.create && hasAccessTo.update)

  return (
    <>
      <Handle style={Styles.handleSource} type="source" position={Position.Left}/>
      <Paper elevation={0} sx={{ ...Styles.nodeWrapper, border: `1px solid ${themeData.palette.customBorderColor.main}`, backgroundColor: (themeMode.isLightBG) ? themeData.palette.background.paper : lighten(themeData.palette.background.default, 0.2) }}>
        {editable && <Tooltip title={'Add Edge gateway'}>
          <IconButton sx={Styles.addIcon}
            onClick={() => showAddModal('edge_gateway', id)} disabled={hasReadOnlyAccess}><AddCircleIcon style={{color: themeData.palette.custom.light, opacity: hasReadOnlyAccess ? '0.5' : 1 }} /></IconButton>
        </Tooltip>}
        <Box sx={Styles.iconWrapper}>
          <CloudIcon style={{color: palette.primary.contrastText}} />
        </Box>
        {/* <Typography sx={{fontSize: '1.1rem', marginLeft: 1, overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 'calc(100% - 90px)'}}>{data.name ? `${data.name} (${data.address})` : 'Cloud'}</Typography> */}
        <Typography sx={{fontSize: '1.1rem', marginLeft: 1, overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 'calc(100% - 90px)'}}>Cloud</Typography>
        <Box sx={Styles.icon} /> {/*Placeholder for icon*/}
      </Paper>
    </>
  );
};
